import { Component, Input } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { ValidationsService } from '../../services/validations.service';

@Component({
  selector: 'shared-validation-message',
  standalone: false,
  template: `
    <div *ngIf="control && control.invalid && (control.touched || submitted)">
      <span class="text-red-500 text-xs mt-1">
        {{ getErrorMessage() }}
      </span>
    </div>
  `,
})
export class ValidationMessageComponent {
  @Input() control!: AbstractControl | NgModel;
  @Input() fieldName!: string;
  @Input() fieldLabel!: string;
  @Input() submitted: boolean = false;

  constructor() {}

  getErrorMessage(): string {
    return ValidationsService.getErrorMessage(
      this.control,
      this.fieldName,
      this.fieldLabel
    );
  }
}
